import Vue from 'vue'
import {mapState} from "vuex";

const initialReaderValidation = Vue.extend({
    computed: {
        ...mapState({
            testerActive: ({challenge: {testerActive}}: any) => testerActive,
            testLevel: ({challenge: {testLevel}}: any) => testLevel,
            initialReaderActive: ({common: {initialReaderActive}}: any) => initialReaderActive,
        }),
        grade() {
            const vm: any = this;
            return vm.course ? vm.course.grade : false
        },
        isInitialReader() {
            const vm: any = this;
            if(!vm.testerActive)
                return this.initialReaderActive &&  ['G0', 'G1st'].some(g => vm.grade === g);

            return vm.testLevel && vm.testLevel.readerType ? vm.testLevel.readerType.value === 1 : false
        }
    },
});

export default initialReaderValidation;
